export default "__VITE_ASSET__42bfe97c__"